import React, { useState, useEffect } from 'react';
import Header from './Component/Header/Header';
import Footer from './Component/Footer/Footer';
import FloatingWhatsApp from './Component/FloatingWhatsApp/FloatingWhatsApp';
import { Home, About, Contact, Privacy, Terms, Products } from './Pages';
import './App.css';
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyD4cYjgRL6Y9THWoL7Zwc7-fK1K-_gi3H0",
  authDomain: "wondereventzz.firebaseapp.com",
  projectId: "wondereventzz",
  storageBucket: "wondereventzz.firebasestorage.app",
  messagingSenderId: "51469615696",
  appId: "1:51469615696:web:53f016e20df570dac1c755",
  measurementId: "G-EV92048ZYM"
};

// Initialize Firebase (only once, outside component)
const app = initializeApp(firebaseConfig);

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [productCategory, setProductCategory] = useState(null);
  const [categoryName, setCategoryName] = useState(null);

  // Initialize Analytics (only in browser, with error handling)
  useEffect(() => {
    if (typeof window !== 'undefined') {
      isSupported().then((supported) => {
        if (supported) {
          try {
            getAnalytics(app);
          } catch (error) {
            console.log('Analytics initialization error:', error);
          }
        }
      }).catch((error) => {
        console.log('Analytics not supported:', error);
      });
    }
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [currentPage]);

  const handleNavigate = (page, category = null, name = null) => {
    setCurrentPage(page);
    if (category) {
      setProductCategory(category);
      setCategoryName(name || null);
    } else {
      setProductCategory(null);
      setCategoryName(null);
    }
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'about':
        return <About />;
      case 'contact':
        return <Contact />;
      case '#privacy':
        return <Privacy />;
      case '#terms':
        return <Terms />;
      case 'products':
        return <Products category={productCategory} categoryName={categoryName} onNavigate={handleNavigate} />;
      default:
        return <Home onNavigate={handleNavigate} />;
    }
  };

  return (
    <div className="App">
      <Header onNavigate={handleNavigate} currentPage={currentPage} />
      {renderPage()}
      <Footer onNavigate={handleNavigate} currentPage={currentPage} />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
